import styled from 'styled-components/macro';
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    useToast
} from "@chakra-ui/react";
import Skeleton from "react-loading-skeleton";
import {useSaveFolders, useSaveToFolder, useUnsaveToFolder} from "../api/save";
import {useFeedback} from "../store/feedback";
import {useModal} from "../store";
import {BareButton} from "./button";
import AddFolder from "./add_folder";
import {themecolors} from "../utils/themecolors";
import {Minus, Plus} from "lucide-react";

const SaveFolder = styled(BareButton)`
  display: flex;
  align-items: baseline;
  padding: 16px 8px;
  font-size: 16px;
  width: 100%;
  text-align: left;
  span {
    flex-grow: 1;
  }
  & svg {
    color: ${({theme}) => theme.color.name === 'dark' ? theme.dark_border : theme.placeholder_gray_2};
  }
    &:hover svg {
      color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.light_high_impact_text};
    }
  ${({theme}) => `
      .react-loading-skeleton {
        background-color: ${theme.skeleton.color};
        background-image: linear-gradient(
                90deg,
                ${theme.skeleton.color},
                ${theme.skeleton.highlightColor},
                ${theme.skeleton.color}
        );
  `}
  }
`;
const Scroll = styled.div`
  max-height: 442px;
  overflow-y: auto;
`;

const SaveFolders = styled(({post, comment, folders, busy, onClose}) => {
    const toast = useToast();
    const {feedbackCh} = useFeedback();
    const id = post ? post.id : comment.id;
    const save = useSaveToFolder(feedbackCh);
    const unsave = useUnsaveToFolder(feedbackCh);
    const handleSave = async (folder, contains) => {
        onClose();
        try {
            await contains ? unsave(id, post ? 'true' : 'false', folder) :
                save(id, post ? 'true' : 'false', folder);
            toast({
                title: `This post has been ${contains ? "unsaved" : "saved"}.`,
                status: 'success',
                isClosable: true,
            })
        } catch {
            // toast.error("Failed to save post.");
        }
    };
    return (
                    <Stack spacing={'5'}>

                        <Scroll>
                            {folders?.map((folder) => (
                                <SaveFolder key={folder.name} onClick={() => handleSave(folder.name, folder.contains)}>
                                    <span>{`${folder.name} (${folder.count})`}</span>
                                    {folder.contains ? <Minus size={18} /> : <Plus size={18} />}
                                </SaveFolder>
                            ))}
                            {busy && Array(3).fill(null).map((_, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <SaveFolder key={index}>
                                    <Skeleton />
                                </SaveFolder>
                            ))}
                        </Scroll>

                    </Stack>

    )
})``

const SaveItem = styled(({post, comment, onClose}) => {
    const {error, busy, feedbackCh} = useFeedback();
    const modal = useModal();
    const type = post ? 'post' : 'comment';
    const id = type === 'post' ? post.id : comment.id;
    const folders = useSaveFolders(feedbackCh, type, id);
    const handleNewFolder = () => {
        modal.open(AddFolder, {post, comment, folders});
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Save this {type}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <SaveFolders
                        post={post}
                        comment={comment}
                        folders={folders}
                        busy={busy}
                        onClose={onClose}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" onClick={handleNewFolder}>New Folder</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})``;

export default SaveItem;
